import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';



const LoginValidation: any = yup.object().shape({
    email: yup.string().required(VALIDATION_MESSAGE.Field("email"))
        .email(VALIDATION_MESSAGE.EMAIL_ADDRESS)
        .matches(VALIDATION_MESSAGE.EMAIL_REGREX, VALIDATION_MESSAGE.EMAIL_ADDRESS)
        .max(150, VALIDATION_MESSAGE.MaxLength('Email', 150))
        .trim(),
    password: yup.string().required(VALIDATION_MESSAGE.Field("password"))
        .min(8, VALIDATION_MESSAGE?.MinLength('Password', 8))
        .max(15, VALIDATION_MESSAGE?.MaxLength('Password', 15))
        .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE),

});

export default LoginValidation;

